import React from 'react';
import './ItemCard.css';

const ItemCard = ({
  item,
  index,
  availableItems,
  showHsnColumn,
  taxType,
  hasdiscount,
  onProductSelect,
  onItemChange,
  onRemoveItem,
  getItemTotal,
  calculateItemTax
}) => {
  // "Subtotal" and "Tax" only if taxable
  const showSubtotal = taxType !== 'NONE';
  const showTax = taxType !== 'NONE' && !hasdiscount;
  const showHSN = showHsnColumn && taxType !== 'NONE';

  return (
    <div className="InvoiceForm__item-card">
      <div className="InvoiceForm__item-header">
        <h3 className="InvoiceForm__item-title">Item {index + 1}</h3>
        <button
          className="InvoiceForm__button InvoiceForm__button--remove"
          onClick={() => onRemoveItem(index)}
          title="Remove item"
        >
          Remove
        </button>
      </div>

      {/* Product & select */}
      <div className="InvoiceForm__product-selection-box">
        <label className="InvoiceForm__label">Product Selection</label>
        <div className="InvoiceForm__product-inputs">
          <div className="InvoiceForm__field-group InvoiceForm__field-group--flex">
            <input
              type="text"
              placeholder="Enter product name"
              className="InvoiceForm__input InvoiceForm__input--product"
              value={item.product_name}
              onChange={(e) => onItemChange(index, 'product_name', e.target.value)}
            />
          </div>
          <div className="InvoiceForm__divider">
            <span>OR</span>
          </div>
          <div className="InvoiceForm__field-group InvoiceForm__field-group--flex">
            <select
              className="InvoiceForm__select InvoiceForm__select--product"
              value={item.product_id}
              onChange={(e) => onProductSelect(index, e.target.value)}
            >
              <option value="">Choose from inventory...</option>
              {availableItems.map((p) => (
                <option key={p.product_id} value={p.product_id}>
                  {p.product_name} - ₹{p.price_selling}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* HSN/SAC */}
      {showHSN && (
        <div className="InvoiceForm__field-group">
          <label className="InvoiceForm__label">HSN/SAC Code</label>
          <input
            type="text"
            placeholder="Enter HSN/SAC code"
            className="InvoiceForm__input"
            value={item.hsn_code}
            onChange={(e) => onItemChange(index, 'hsn_code', e.target.value)}
          />
        </div>
      )}

      <div className="InvoiceForm__grid-2">
        <div className="InvoiceForm__field-group">
          <label className="InvoiceForm__label">Quantity</label>
          <input
            type="number"
            min="1"
            className="InvoiceForm__input"
            value={item.quantity}
            onChange={(e) => {
              const value = e.target.value;
              const numValue = value === '' ? '' : Math.max(1, parseInt(value) || 1);
              onItemChange(index, 'quantity', numValue);
            }}
          />
        </div>

        <div className="InvoiceForm__field-group">
          <label className="InvoiceForm__label">Unit Price (₹)</label>
          <input
            type="number"
            min="0"
            step="0.01"
            className="InvoiceForm__input"
            value={item.unit_price}
            onChange={(e) => onItemChange(index, 'unit_price', parseFloat(e.target.value) || 0)}
          />
        </div>
      </div>

      <div className="InvoiceForm__field-group">
        <label className="InvoiceForm__label">Description</label>
        <textarea
          placeholder="Enter item description..."
          className="InvoiceForm__textarea"
          value={item.description}
          onChange={(e) => onItemChange(index, 'description', e.target.value)}
        />
      </div>

      <div className="InvoiceForm__grid-info">
        {/* Subtotal */}
        {showSubtotal && (
          <div className="InvoiceForm__info-item">
            <strong>Subtotal:</strong> ₹{getItemTotal(item).toFixed(2)}
          </div>
        )}
        {/* Tax */}
        {showTax && (
          <div className="InvoiceForm__info-item">
            <strong>Tax:</strong> ₹{calculateItemTax(item).toFixed(2)}
          </div>
        )}
        {/* Total */}
        <div className="InvoiceForm__info-item InvoiceForm__info-item--total">
          <strong>Total:</strong> ₹
          {(
            showSubtotal
              ? getItemTotal(item) + calculateItemTax(item)
              : getItemTotal(item)
          ).toFixed(2)}
        </div>
      </div>
    </div>
  );
};

export default ItemCard;
